import { useTypedQuery } from "hooks";
import { WebhooksQueryKeys } from "modules/WebhooksDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useWebhookErrorsQuery = ({ webhook_id, page, page_size }: { webhook_id: number | null; page: number; page_size: number }) =>
  useTypedQuery({
    queryKey: WebhooksQueryKeys.errors,
    queryFn: async () => (await ApiInstance.post(WebhooksQueryKeys.errors.endpoint, { webhook_id, page, page_size }, WebhooksQueryKeys.errors.baseUrl)).data,
    enabled: false,
    refetchOnDependencies: [webhook_id, page, page_size]
  });
